import React, { useMemo } from 'react';
import { View, Text, StyleSheet, Platform, type TextStyle, type ViewStyle } from 'react-native';
import { appTheme, type ThemeColors } from '../../shared/theme';
import { hexToRgba } from '../../shared/theme/colorUtils';
import { androidScaleFont } from '../../shared/theme/studio/stackScreenShell';
import { useRtl } from '../../shared/i18n/useRtl';

const ANDROID_TEXT_COMPACT: TextStyle = Platform.OS === 'android' ? { includeFontPadding: false } : {};

type Props = {
  colors: ThemeColors;
  title: string;
  subtitle: string;
  style?: ViewStyle;
};

export function JourneyStepIntro({ colors, title, subtitle, style }: Props) {
  const rtl = useRtl();
  const sf = androidScaleFont;
  const styles = useMemo(() => createStyles(colors, sf), [colors]);

  return (
    <View style={[styles.wrap, style]}>
      <View
        style={[
          styles.accent_line,
          { backgroundColor: hexToRgba(colors.primary, 0.35), alignSelf: rtl.isRTL ? 'flex-end' : 'flex-start' },
        ]}
      />
      <Text style={[styles.title, { textAlign: rtl.textAlign, writingDirection: rtl.writingDirection }]}>{title}</Text>
      <Text style={[styles.subtitle, { textAlign: rtl.textAlign, writingDirection: rtl.writingDirection }]}>{subtitle}</Text>
    </View>
  );
}

function createStyles(c: ThemeColors, sf: (n: number) => number) {
  return StyleSheet.create({
    wrap: {
      marginBottom: appTheme.spacing.xl,
    },
    accent_line: {
      width: sf(36),
      height: 3,
      borderRadius: 999,
      marginBottom: appTheme.spacing.md,
    },
    title: {
      fontSize: sf(30),
      lineHeight: sf(36),
      fontWeight: '800',
      letterSpacing: -0.6,
      color: c.text,
      marginBottom: appTheme.spacing.sm,
      ...ANDROID_TEXT_COMPACT,
    },
    subtitle: {
      fontSize: sf(15),
      lineHeight: sf(23),
      fontWeight: '500',
      color: hexToRgba(c.text, 0.72),
      maxWidth: '96%',
      ...ANDROID_TEXT_COMPACT,
    },
  });
}
